import { render, staticRenderFns } from "./DisplayStripes.vue?vue&type=template&id=306c4f70&scoped=true&lang=html&"
import script from "./DisplayStripes.vue?vue&type=script&lang=js&"
export * from "./DisplayStripes.vue?vue&type=script&lang=js&"
import style0 from "./DisplayStripes.vue?vue&type=style&index=0&id=306c4f70&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306c4f70",
  null
  
)

export default component.exports